import React from 'react';

const DividerModule = () => (
    <section className="marketing-container__max-width">
        <div className="mktg-layout-align--horizontal-desktop ">
            <div className="eds-g-cell-12-12">
                <hr />
            </div>
        </div>
    </section>
);

export default DividerModule;
